import { Paper, SimpleGrid, Stack, Text, Title, UnstyledButton } from '@mantine/core';
import { Logo } from '@medplum/react';
import { IconLogin, IconUserPlus } from '@tabler/icons-react';
import type { JSX } from 'react';
import { useNavigate } from 'react-router';
import classes from './pcp-referral/PCPReferralPage.module.css';

interface OptionCardProps {
  icon: JSX.Element;
  title: string;
  description: string;
  onClick: () => void;
}

function OptionCard({ icon, title, description, onClick }: OptionCardProps): JSX.Element {
  return (
    <UnstyledButton onClick={onClick} style={{ display: 'block', width: '100%' }}>
      <Paper
        p="xl"
        radius="md"
        shadow="sm"
        style={{ height: '100%', transition: 'box-shadow 0.15s ease' }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLElement).style.boxShadow = 'var(--mantine-shadow-md)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLElement).style.boxShadow = '';
        }}
      >
        <Stack gap="sm">
          {icon}
          <Title order={4}>{title}</Title>
          <Text c="dimmed" size="sm">
            {description}
          </Text>
        </Stack>
      </Paper>
    </UnstyledButton>
  );
}

export function LandingPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.logo}>
          <Logo size={48} />
        </div>
        <Paper p="xl" radius="md" shadow="sm" mb="md">
          <Title order={2} ta="center" mb={4}>
            Provider Portal
          </Title>
          <Text c="dimmed" ta="center" size="sm">
            What would you like to do?
          </Text>
        </Paper>
        <SimpleGrid cols={2} spacing="md">
          <OptionCard
            icon={<IconLogin size={32} stroke={1.5} color="var(--mantine-color-blue-6)" />}
            title="Sign In"
            description="Access your provider dashboard to manage patients, tasks, and messages."
            onClick={() => {
              navigate('/signin')?.catch(console.error);
            }}
          />
          <OptionCard
            icon={<IconUserPlus size={32} stroke={1.5} color="var(--mantine-color-blue-6)" />}
            title="Submit a Patient Referral"
            description="Refer a patient to our sleep program without needing an account."
            onClick={() => {
              navigate('/pcp-referral')?.catch(console.error);
            }}
          />
        </SimpleGrid>
      </div>
    </div>
  );
}
